import { createInjectionKey as e } from "./highrise529.mjs";
const n = e("n-drawer-body"), o = e("n-drawer");
export {
  n as drawerBodyInjectionKey,
  o as drawerInjectionKey
};
